import { render } from "./branch-ord.vue?vue&type=template&id=3f0e5cc1"
import script from "./branch-ord.vue?vue&type=script&lang=js"
export * from "./branch-ord.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__